/* Model */
class CheckpointItemReasonModel extends App.Models.BaseModel {
  modelUrl = 'CheckpointItemReason';
}
App.Models.CheckpointItemReason = CheckpointItemReasonModel;

/* Collection */
class CheckpointItemReasonCollection extends App.Collections.BaseCollection {
  url = 'CheckpointItemReason';
  model = App.Models.CheckpointItemReason;
}
App.Collections.CheckpointItemReasons = CheckpointItemReasonCollection;

/* Router */
class CheckpointItemReasonRouter extends App.Routers.BaseRouter {
  constructor() {
      const entityName = 'CheckpointItemReason';
      const model = App.Models.CheckpointItemReason;
      const collectionClass = App.Collections.CheckpointItemReasons;

      super(entityName, model, collectionClass);
  }
}

App.Routers.CheckpointItemReason = CheckpointItemReasonRouter; 